import '../../blocks/articles-slider/articles-slider.js';
